import { Button, Icon } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { useSelectAndLink } from 'site/Renderer/components/SelectAndLink'
import { targetComponents } from 'site/Renderer/components/SelectAndLink/SelectAndLink.constants'
import { useSiteState } from 'siteState/shared'
import { SelectAndLinkButtonProps } from './TableActions.types'

const SelectAndLinkButton = ({
  selectAndLinkOptions,
  objectclassUuid,
  objectClassTitle,
  hideSelectAndLinkAction,
  selectAndLinkTargetPath,
  variant = 'text',
  disableLinkButton
}: SelectAndLinkButtonProps) => {
  const { openSelectAndLink } = useSelectAndLink()
  const [, setRequestObjectAreaResetOnNextFetch] = useSiteState<boolean>(
    'request-object-area-reset-on-next-fetch'
  )

  const handleOpenSelectAndLink = useMemo(() => {
    if (!objectclassUuid || !selectAndLinkOptions) return undefined
    const config = {
      targetField: selectAndLinkOptions.targetField,
      targetGroup: selectAndLinkOptions.targetGroup,
      objectclassUuid,
      objectClassTitle: objectClassTitle ?? '',
      targetComponent: selectAndLinkOptions.targetComponent,
      selectedOptions: selectAndLinkOptions.selectedOptions,
      targetPath: selectAndLinkTargetPath,
      uniselection: selectAndLinkOptions.uniselection
    }
    const sessionId =
      selectAndLinkOptions.targetComponent === targetComponents.OBJECT_VIEW
        ? selectAndLinkOptions.targetField
        : undefined
    return () => openSelectAndLink(config, sessionId)
  }, [
    objectclassUuid,
    objectClassTitle,
    selectAndLinkOptions,
    selectAndLinkTargetPath,
    openSelectAndLink
  ])

  const { t } = useTranslation()

  if (hideSelectAndLinkAction || !handleOpenSelectAndLink) {
    return null
  }

  const handleSelectAndLinkClick = () => {
    if (disableLinkButton) {
      setRequestObjectAreaResetOnNextFetch(true)
    }
    handleOpenSelectAndLink?.()
  }

  if (variant === 'icon') {
    return (
      <Button
        variant='secondary'
        onClick={handleSelectAndLinkClick}
        aria-label={t('data-tables.select-and-link')}
        style={{ minWidth: '40px' }}
      >
        <Icon iconName='SelectAndRelateSign' icSize='semiSmall' />
      </Button>
    )
  }

  return (
    <Button
      variant='secondary'
      heightClass='semiSmall'
      onClick={handleSelectAndLinkClick}
    >
      {t('data-tables.select-and-link')}
    </Button>
  )
}

export default SelectAndLinkButton
